import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowRight, FiArrowLeft } from 'react-icons/fi';
import {
  RELATED_FEATURES, FEATURE_VERTICALS, VERTICAL_FEATURES, VERTICAL_ROUTE, featurePath,
} from '../../seo/relatedLinks';
import styles from './styles.module.css';

/**
 * The links that turn a set of pages into a subject.
 *
 * Renders nothing when a page has no declared relationships, so it can be
 * mounted unconditionally without inventing links for pages that have none.
 */
const RelatedLinks = ({ scope, pageKey, color = '#F36523' }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar' || i18n.language === 'he';
  const Arrow = isRtl ? FiArrowLeft : FiArrowRight;

  const features = scope === 'features'
    ? (RELATED_FEATURES[pageKey] || [])
    : (VERTICAL_FEATURES[pageKey] || []);
  const verticals = scope === 'features' ? (FEATURE_VERTICALS[pageKey] || []) : [];

  if (!features.length && !verticals.length) return null;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.grid}>
          {features.length > 0 && (
            <div className={styles.col}>
              <h2 className={styles.title}>{t('features.common.relatedTitle')}</h2>
              <ul className={styles.list}>
                {features.map((k) => (
                  <li key={k}>
                    <Link to={featurePath(k)} className={styles.link} style={{ color }}>
                      <span>{t(`features.cards.${k}.title`)}</span>
                      <Arrow aria-hidden="true" className={styles.arrow} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {verticals.length > 0 && (
            <div className={styles.col}>
              <h2 className={styles.title}>{t('features.common.relatedBusinesses')}</h2>
              <ul className={styles.list}>
                {verticals.map((k) => (
                  <li key={k}>
                    <Link to={`/for/${VERTICAL_ROUTE[k]}`} className={styles.link} style={{ color }}>
                      <span>{t(`businesses.cards.${k}.title`)}</span>
                      <Arrow aria-hidden="true" className={styles.arrow} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default RelatedLinks;
